// removed by extract-text-webpack-plugin
module.exports = {"root":"HBp0U_HB","loading":"_3JLEJ_3J","link":"_370gz_37","default":"_3O9-A_3O","primary":"_8YxFT_8Y","inverted":"_1pxQs_1p","green":"_2pQFU_2p","red":"WRwzr_WR","orange":"_10LEx_10","dark":"TpMEw_Tp","border":"_1_upe_1_","textLink":"_3CN4u_3C","wide":"_2Q3dv_2Q","small":"_1cGiE_1c","large":"_2-GW8_2-","block":"SNFpw_SN","load":"gE5GS_gE"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Button/Button.css
// module id = 488
// module chunks = 0